import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { StudentInvoicingPropiosV3Service } from '../../pages/students-portal/student-invoicing-propios-v3/student-invoicing-propios-v3.service';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate {

  constructor(private router: Router, private serviceInfo: StudentInvoicingPropiosV3Service) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const moduleId = next.data['id'];
      return this.serviceInfo.getItsUnderMaintenance(moduleId).pipe(
        map((response: any) => {
          if (response.maintenance) {
            this.router.navigate(['/maintenance']);
            return false;
          }
          return true;
        }),
        catchError(() => {
          this.router.navigate(['/error']); 
          return of(false);
        })
      );
  }
}
